import { render, staticRenderFns } from "./NightCopyText.vue?vue&type=template&id=664e639e&scoped=true"
import script from "./NightCopyText.vue?vue&type=script&lang=js"
export * from "./NightCopyText.vue?vue&type=script&lang=js"
import style0 from "./NightCopyText.vue?vue&type=style&index=0&id=664e639e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "664e639e",
  null
  
)

export default component.exports